var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1058 483L1058 511",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1058.5,
    cy: 478.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.99 478.19C1053.99 474.283 1057.29 471.117 1061.36 471.117C1061.94 471.117 1062.51 471.184 1063.06 471.308C1061.74 470.48 1060.19 470 1058.52 470C1053.81 470 1050 473.806 1050 478.5C1050 483.194 1053.81 487 1058.52 487C1060.81 487 1062.89 486.093 1064.43 484.62C1063.49 485.032 1062.45 485.263 1061.36 485.263C1057.29 485.263 1053.99 482.096 1053.99 478.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.4 477.6L1067.37 475.146L1065.54 476.719L1063.3 476.056L1064.11 478.337L1062.77 480.381L1065.1 480.218L1066.5 482.144L1067.13 479.763L1069.34 478.909L1067.4 477.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.381f50a014eadb330a72fc6376178da6.svg";
export { ForwardRef as ReactComponent };